export default "__VITE_ASSET__DkOoOW3N__"